declare const jQuery: any;
const $ = jQuery;

export function initOwlCarousel(): void
{
    $('.products-carousel .owl-carousel').owlCarousel({
        responsive : {
            0 : {
                items: 1,
            },
            768 : {
                items: 2,
                margin: 25,
            },
            1260 : {
                items: 4,
                margin: 50,
            }
        },
        dots: false,
        autoplay: true,
        autoplayHoverPause: true,
        autoplaySpeed: 2000,
        autoplayTimeout: 4000,
        loop: true,
        lazyLoad: true,
    });
}
